<template>
  <div class="right-box" v-if="show && siteBar">
    <ul>
      <li v-if="!isC" @click="onlineChat()">
        <i class="iconfont iconzixun"></i>
        <span>在线咨询</span>
      </li>
      <li v-if="!isC">
        <el-tooltip
          class="item"
          popper-class="kefu"
          effect="dark"
          placement="left"
          offset="2"
        >
          <div slot="content" style="font-size: 12px">
            考生客服：<span v-html="customerService"
              >0851-88622569 010-85359782</span
            ><br />
            企业咨询：<span v-html="webconfig.Landline">400-060-8006</span>
          </div>
          <div class="inner">
            <i
              class="iconfont icondianhua1"
              style="margin-bottom: -6px; padding-top: 2px"
            ></i>
            <span>电话咨询</span>
          </div>
        </el-tooltip>
      </li>
      <li v-if="shiyong" @click="compRegistor">
        <i class="iconfont icondiannao"></i>
        <span>试用</span>
      </li>
      <li class="backTop" @click="fullpageTop" v-if="fullpage">
        <i class="iconfont iconzhiding"></i>
        <span>TOP</span>
      </li>
      <back-to-top v-if="!fullpage" :class="{ down: isC }">
        <li class="backTop">
          <i class="iconfont iconzhiding"></i>
          <span>TOP</span>
        </li>
      </back-to-top>
    </ul>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop'
export default {
  components: { BackToTop },
  data() {
    return {
      show: true,
      siteBar: true,
      webconfig: {},

      shiyong: true,
      fullpage: false,

      isC: false,
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.app.device
    },
    loadRightBar() {
      return this.$store.state.app.rightBar
    },
    loadConfig() {
      return this.$store.state.app.config
    },
    customerService(){
      if(this.$store.state.app.config && this.$store.state.app.config.concat && this.$store.state.app.config.concat.customerService){
        let hostname = location.host.replace(/\./g, '_')
        if(typeof this.$store.state.app.config.concat.customerService == "object"){
          if (this.$store.state.app.config.concat.customerService[hostname]) {
            return this.$store.state.app.config.concat.customerService[
              hostname
            ]
          } else {
            return this.$store.state.app.config.concat.customerService[
              'default'
            ]
          }
        }
        else{
          return this.$store.state.app.config.concat.customerService
        }
      }else{
        return "";
      }
    }
  },
  mounted() {
    if (this.isMobile) {
      this.show = false
    }
    if (this.$store.state.app.config && this.$store.state.app.config.concat) {
      this.webconfig = this.$store.state.app.config.concat
    }
    this.isC = this.$route.path.indexOf('practice') > -1
    this.routeChange()
  },
  watch: {
    loadConfig(newVal, oldVal){
      if (newVal && newVal.concat) {
        this.webconfig = newVal.concat
      }
    },
    isMobile(newVal, oldVal) {
      if (newVal == 1) {
        this.show = false
      } else {
        this.show = true
      }
    },
    
    loadRightBar(newVal, oldVal) {
      this.siteBar = newVal
    },
    $route: {
      handler: function (val, oldVal) {
        this.isC = val.path.indexOf('practice') > -1
        if (val != oldVal) {
          this.routeChange()
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    routeChange() {
      if (this.$route.path.indexOf('/practice') > -1) {
        this.shiyong = false
      } else {
        this.shiyong = true
      }
      if (
        this.$route.path == '/home' ||
        this.$route.path == '/product/interview'
      ) {
        this.fullpage = true
      } else {
        this.fullpage = false
      }
    },
    compRegistor() {
      this.$bus.emit('compRegisterChoose')
    },
    onlineChat() {
      this.$bus.emit('chatShow')
    },
    fullpageTop() {
      this.$bus.emit('fullpageTop')
    },
  },
}
</script>

<style lang="scss" scoped>
.right-box {
  position: fixed;
  right: 10px;
  top: 50%;
  margin-top: -120px;
  z-index: 9;
  ul {
    margin: 0px;
    padding: 0px;
    li {
      list-style: none;
      margin: 0px;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: #fff;
      width: 64px;
      height: 56.8px;
      color: rgb(41, 189, 185);
      border: 1px solid rgb(41, 189, 185);
      padding: 4px 7px 2px 7px;
      margin-bottom: 10px;
      cursor: pointer;
      span {
        font-size: 12px;
      }
      i {
        font-size: 22px;
        display: block;
        width: 100%;
      }
      &.backTop {
        span {
          display: none;
          margin-top: -6px;
          font-size: 18px;
        }
        i {
          margin-top: -6px;
          display: block;
        }
        &:hover {
          span {
            display: block;
          }
          i {
            display: none;
          }
        }
      }
    }
    .down {
      margin-top: 200px;
    }

    li:hover {
      background: rgb(41, 189, 185);
      color: #fff;
      width: 64px;
      height: 56.8px;
    }
  }
}
.vue-back-to-top {
  position: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/rightbar/index.vue